<template>
  <div class="ctrlRow">
    <div class="ctrlHolder">
      <div class>Options</div>
      <v-alert v-if="field.missingOptions" type="warning" dense color="orange">Option manquante</v-alert>

      <v-data-table :headers="headers" :items="field.options" dense>
        <template v-slot:item.action="{ item }">
          <v-btn small icon @click="up(item)">
            <v-icon small>mdi-chevron-up</v-icon>
          </v-btn>
          <v-btn small icon @click="edit(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>

          <v-dialog v-model="images[item.id]" max-width="980">
            <template v-slot:activator="{on}">
              <v-btn small icon v-on="on">
                <v-icon small>mdi-image</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Gestion des images pour cette option</v-card-title>
              <v-card-text>
                <option-images :optionId="item.id" />
              </v-card-text>
              <v-card-actions>
                <v-btn @click="images[item.id]=false">Fermer</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn small icon @click="deleteItem(item)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>

          <v-btn small icon @click="down(item)">
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.upcharge="{item}">{{$format.money(item.upcharge)}}</template>
      </v-data-table>
      <div class>
        <v-btn
          dark
          x-small
          color="blue"
          @click="addOption()"
          v-if="field.options.length<maxOptions"
        >
          <v-icon small left>mdi-plus</v-icon>Ajouter
        </v-btn>
        <v-dialog v-model="optionForm" persistent max-width="980px">
          <v-card>
            <v-toolbar>
              <v-toolbar-title>Options</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field v-model="option.label" label="Label" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field v-model="option.value" label="Value" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field v-model="option.upcharge" label="Upcharge" />
                    </v-col>
                  </v-row>
                  <v-row v-if="currentService.api && apiValues">
                    <v-col>
                      <v-text-field v-model="option.api_value" label="Champ APsI" />
                      <v-select
                        label="Champ API"
                        v-model="option.api_value"
                        :items="apiValues"
                        item-text="value"
                        item-value="id"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="cancel()">Annuler</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="save()">Sauver</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import OptionImages from "./FieldOptionImage.vue";
export default {
  components: {
    OptionImages
  },
  name: "FieldOptions",
  props: {
    field: {
      type: Object,
      default: () => ({})
    },
    step: {
      type: Object,
      required: true
    },
    maxOptions: {
      type: Number,
      default: 999999
    }
  },
  computed: {
    ...mapState("services", {
      currentService: state => state.currentService
    })
  },
  data: () => ({
    apiValues: [],
    optionForm: false,
    valid: false,
    images: {},
    option: {
      label: null,
      value: null,
      upcharge: null,
      api_value: null
    },
    defaultOption: {
      label: null,
      value: null,
      upcharge: null,
      api_value: null
    },
    verificationMessage: {
      submitStatus: null,
      message: ""
    },
    headers: [
      { text: "Label", value: "label" },
      { text: "Upcharge", value: "upcharge" },
      { text: "Actions", value: "action", align: "right" }
    ]
  }),
  mounted: function() {
    this.getAvailableApiValues();
  },
  methods: {
    getAvailableApiValues() {
      if (this.currentService.api) {
        this.$store
          .dispatch("field-options/getAvailableApiValues", {
            step: this.step,
            field: this.field
          })
          .then(data => {
            this.apiValues = data;
          });
      }
    },
    save() {
      this.$store
        .dispatch("field-options/save", {
          step: this.step,
          field: this.field,
          option: this.option
        })
        .then(() => {
          this.$emit("refresh");
        });
    },

    async validateBeforeSubmit() {
      this.$v.$touch();
      if (!this.$v.$error) {
        if (this.option.id) {
          await axios
            .put(
              "service/" +
                this.step.services_id +
                "/step/" +
                this.step.id +
                "/block/" +
                this.field.block_id +
                "/field/" +
                this.field.id +
                "/option/" +
                this.option.id,
              this.option
            )
            .then(
              function(response) {
                if (response.status === 200) {
                  this.$emit("add");
                  this.optionForm = false;
                  this.option = Object.assign({}, this.defaultOption);
                }
              }.bind(this)
            )
            .catch(function(error) {
              console.log(error);
            });
        } else {
          await axios
            .post(
              "service/" +
                this.step.services_id +
                "/step/" +
                this.step.id +
                "/block/" +
                this.field.block_id +
                "/field/" +
                this.field.id +
                "/option",
              this.option
            )
            .then(
              function(response) {
                if (response.status === 200) {
                  this.$emit("add");
                  this.optionForm = false;
                  this.option = Object.assign({}, this.defaultOption);
                }
              }.bind(this)
            )
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    async deleteItem(item) {
      await axios
        .delete(
          "service/" +
            this.step.services_id +
            "/step/" +
            this.step.id +
            "/block/" +
            this.field.block_id +
            "/field/" +
            this.field.id +
            "/option/" +
            item.id
        )
        .then(
          function(response) {
            if (response.status === 200) {
              this.$emit("delete");
              this.optionForm = false;
            }
          }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
        });
    },
    edit(item) {
      this.option = Object.assign({}, item);
      this.optionForm = true;
    },
    addOption() {
      this.optionForm = true;
    },
    cancel() {
      this.option = this.defaultOption;
      this.optionForm = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
